import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './pages/auth/Login';
import { ThemeProvider } from './providers/ThemeProvider';
import AddNewUser from './pages/user/Add';
import Projects from './pages/projects/Projects';
import ExternalProjects from './pages/projects/ExternalProjects';
import ProjectDetail from './pages/projects/ProjectDetail';
import Settings from './pages/settings/settings';
import Results from './pages/results/Results';
import Dashboard from './pages/dashboard/Dashboard';

const AppRoutes: React.FC = () => {
  return (
    <ThemeProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/user/add" element={<AddNewUser />} />
          <Route path="/results" element={<Results />} />
          <Route path="/internal-projects/*" element={<Projects />} />
          <Route path="/projects/*" element={<Projects />} />
          <Route path="/external-projects/*" element={<ExternalProjects />} />
          <Route path="/:projectName/*" element={<ProjectDetail />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/" element={<Dashboard />} />
        </Routes>
    </ThemeProvider>
  );
};

export default AppRoutes; 